<template>
  <v-app>
    <fma-header />
    <router-view />
    <v-footer app absolute color="secondary" class="white--text">
      <v-card class="pl-2 white--text" color="secondary" elevation="0">
        {{
          `Made Possible by:    ${sponsors
            .map(sponsor => sponsor.name.replace(" ", "&nbsp;"))
            .join(" ・ ")}`
        }}
      </v-card>
      <v-spacer />
      <v-card
        v-if="!$store.state.kioskMode"
        class="white--text"
        color="secondary"
        elevation="0"
      >
        <router-link
          :to="{ name: 'Provider-Login' }"
          class="white--text footer-link"
        >
          Submit a listing
        </router-link>
      </v-card>
      <v-spacer v-if="!$store.state.kioskMode" />
      <v-card class="pr-2 white--text" color="secondary" elevation="0">
        @{{ new Date().getFullYear() }} Fort Meade Alliance Foundation
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
import FmaHeader from "@/components/FmaHeader.vue";
import { mapMutations } from "vuex";

const IDLE_TIMEOUT_MS = 5 * 60 * 1000; // 5 minutes
const IDLE_EVENTS = ["click", "touchstart", "mousemove", "keydown"];

export default {
  components: {
    FmaHeader
  },
  data() {
    return {
      idleTimer: null
    };
  },
  computed: {
    sponsors() {
      return this.$store.state.sponsors;
    }
  },
  mounted() {
    this.$store.dispatch("fetchSponsors");
    if (this.$store.state.kioskMode) {
      IDLE_EVENTS.forEach(event =>
        document.addEventListener(event, this.resetIdleTimer, { passive: true })
      );
      this.startIdleTimer();
    }
  },
  beforeDestroy() {
    IDLE_EVENTS.forEach(event =>
      document.removeEventListener(event, this.resetIdleTimer)
    );
    clearTimeout(this.idleTimer);
  },
  created() {
    /* Check for kiosk mode flag, if not kiosk mode and entering home screen then direct right to categories */
    const {
      query: { kiosk = undefined },
      name
    } = this.$route;
    if (!kiosk && name == "Home") this.$router.push({ name: "Categories" });
    this.assignKioskMode(!!kiosk);
  },
  methods: {
    ...mapMutations(["assignKioskMode"]),
    startIdleTimer() {
      this.idleTimer = setTimeout(() => {
        if (this.$route.name !== "Home") {
          this.$router.push({ name: "Home" });
        }
      }, IDLE_TIMEOUT_MS);
    },
    resetIdleTimer() {
      clearTimeout(this.idleTimer);
      this.startIdleTimer();
    }
  }
};
</script>

<style lang="less">
@import "./assets/global.less";

.footer-link {
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
}
</style>
